// FlowSpace Theme JS
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-option__value').forEach(function(label) {
    label.addEventListener('click', function() {
      var siblings = this.parentElement.querySelectorAll('.product-option__value');
      siblings.forEach(function(s) { s.classList.remove('selected'); });
      this.classList.add('selected');
    });
  });
});

// FlowSpace cart adapter for Fast Bundle and theme add-to-cart actions.
(function() {
  var drawer;
  var drawerBody;
  var drawerCount;
  var lastFocusedElement;

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format((Number(cents) || 0) / 100);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function updateCartCount(count) {
    document.querySelectorAll('.header__cart').forEach(function(link) {
      link.textContent = 'Cart (' + count + ')';
    });
    if (drawerCount) drawerCount.textContent = count;
  }

  function renderCart(cart) {
    if (!drawerBody) return cart;
    updateCartCount(cart.item_count || 0);

    if (!cart.items || !cart.items.length) {
      drawerBody.innerHTML = '<div class="fs-cart-drawer__empty"><strong>Your cart is empty.</strong><a href="/collections/all">Continue shopping</a></div>';
      return cart;
    }

    var items = cart.items.map(function(item) {
      var image = item.image
        ? '<img src="' + escapeHtml(item.image) + '&width=180" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
        : '<span class="fs-cart-drawer__image-placeholder"></span>';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<small>' + escapeHtml(item.variant_title) + '</small>'
        : '';
      var price = item.final_line_price === 0
        ? '<strong class="fs-cart-drawer__free">FREE</strong>'
        : '<strong>' + money(item.final_line_price) + '</strong>';
      var original = item.original_line_price > item.final_line_price
        ? '<s>' + money(item.original_line_price) + '</s>'
        : '';

      return '<article class="fs-cart-drawer__item">' +
        '<a class="fs-cart-drawer__image" href="' + escapeHtml(item.url) + '">' + image + '</a>' +
        '<div class="fs-cart-drawer__item-copy">' +
          '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
          variant +
          '<span>Qty ' + item.quantity + '</span>' +
        '</div>' +
        '<div class="fs-cart-drawer__item-price">' + original + price + '</div>' +
      '</article>';
    }).join('');

    drawerBody.innerHTML = '<div class="fs-cart-drawer__items">' + items + '</div>' +
      '<div class="fs-cart-drawer__summary">' +
        '<div><span>Subtotal</span><strong>' + money(cart.total_price) + '</strong></div>' +
        '<p>Shipping is free to the lower 48.</p>' +
        '<a class="fs-cart-drawer__checkout" href="/checkout">Checkout</a>' +
        '<a class="fs-cart-drawer__view-cart" href="/cart">View cart</a>' +
      '</div>';
    return cart;
  }

  function update() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Unable to refresh cart');
        return response.json();
      })
      .then(renderCart);
  }

  function revealDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('fs-cart-drawer-open');
    var closeButton = drawer.querySelector('[data-fs-cart-close]');
    if (closeButton) closeButton.focus({ preventScroll: true });
  }

  function open() {
    lastFocusedElement = document.activeElement;
    revealDrawer();
    return update().then(function(cart) {
      return cart;
    }).catch(function(error) {
      console.warn('[FlowSpaceCart] Drawer refresh failed; keeping drawer open', error);
      if (drawerBody && !drawerBody.querySelector('.fs-cart-drawer__items')) {
        drawerBody.innerHTML = '<div class="fs-cart-drawer__empty"><strong>Your cart was updated.</strong><a href="/cart">View cart</a></div>';
      }
      return { refreshFailed: true };
    });
  }

  function close() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('fs-cart-drawer-open');
    window.setTimeout(function() {
      drawer.hidden = true;
    }, 220);
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus({ preventScroll: true });
    }
  }

  function bindProductForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
      if (form.dataset.flowspaceAjaxCart === 'true') return;
      form.dataset.flowspaceAjaxCart = 'true';

      form.addEventListener('submit', function(event) {
        if (event.defaultPrevented) return;
        event.preventDefault();

        var submitButton = event.submitter || form.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
        }

        fetch(form.action, {
          method: form.method || 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        })
          .then(function(response) {
            if (!response.ok) return response.json().then(function(error) { throw error; });
            return response.json();
          })
          .then(function() {
            return open();
          })
          .catch(function(error) {
            console.error('[FlowSpaceCart] Add to cart failed', error);
            window.location.assign('/cart');
          })
          .finally(function() {
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.removeAttribute('aria-busy');
            }
          });
      });
    });
  }

  function init() {
    drawer = document.getElementById('FlowSpaceCartDrawer');
    drawerBody = drawer && drawer.querySelector('[data-fs-cart-body]');
    drawerCount = drawer && drawer.querySelector('[data-fs-cart-count]');

    if (drawer) {
      drawer.addEventListener('click', function(event) {
        if (event.target.closest('[data-fs-cart-close]')) close();
      });
    }
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') close();
    });
    bindProductForms();
    update().catch(function(error) {
      console.warn('[FlowSpaceCart] Initial refresh failed', error);
    });
  }

  window.FlowSpaceCart = {
    update: update,
    refresh: update,
    open: open,
    close: close
  };
  // Explicit aliases Fast Bundle support can configure if needed.
  window.flowspaceCartUpdate = update;
  window.flowspaceOpenCart = open;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
